//* Libraries imports
type PixQRCodeProps = {
  encodedImage?: string;
  loading?: boolean;
};

export function PixQRCode({ encodedImage, loading }: PixQRCodeProps) {
  if (loading) {
    return (
      <div className="size-48 flex items-center justify-center bg-white rounded-lg p-2 shadow-sm border border-gray-100">
        <div className="animate-spin rounded-full size-8 border-b-2 border-claroprimaria-01"></div>
      </div>
    );
  }

  if (!encodedImage) {
    return (
      <div className="size-48 flex items-center justify-center bg-white rounded-lg p-2 shadow-sm border border-gray-100">
        <p className="text-xs text-gray-400 text-center">
          QR Code não disponível
        </p>
      </div>
    );
  }

  return (
    <div className="size-48 flex items-center justify-center bg-white rounded-lg p-2 shadow-sm border border-gray-100 overflow-hidden">
      <img
        src={`data:image/png;base64,${encodedImage}`}
        alt="Pix QR Code"
        className="size-full object-contain"
      />
    </div>
  );
}
